import { Language } from "./language";
import { TranslationMode } from './translation-mode';
import { LocalizedString } from './localized-string';

export enum JobType {
	Import = 'import',
	Translation = 'translation'
}

export enum JobStatus {
	Pending = 'pending',
	Processing = 'processing',
	Running = 'running',
	Completed = 'completed',
	Failed = 'failed',
	MaxRetriesExceeded = 'max_retries_exceeded'
}

export interface JobRef {
	jobId: string;
	jobType: JobType;
}

/**
 * Error information for a failed job
 */
export interface JobErrorInfo {
	userMessage: LocalizedString;
	code: string;
	errorDate: number; // timestamp
}

export interface ProgressItem {
	jobRef: JobRef;
	total: number;
	completed: number;
	percentage: number;
	status: JobStatus;
	currentOperation?: LocalizedString;
	lastUpdate?: number;
	retryCount?: number;
	lastError?: JobErrorInfo;
	hasError?: boolean;
}

export interface NewsSyncRequest {
	userId?: string;
	categoryId?: string;
	sourceLanguage: Language;
}

export interface NewsSyncOnlyRequest {
	userId?: string;
	categoryId: string;
	sourceLanguage: Language;
}

export interface NewsTranslateRequest {
	userId?: string;
	sourceLanguage: Language;
	targetLanguage: Language;
	categoryId: string;
	mode: TranslationMode;
}

export interface NewsSyncResponse {
	status: 'started' | 'completed' | 'already_running';
	progressItems: ProgressItem[];
}

export interface PremiumSyncRequest {
	userId?: string;
}
